import { render, staticRenderFns } from "./MatImage.vue?vue&type=template&id=9a4beef4&"
import script from "./MatImage.vue?vue&type=script&lang=ts&"
export * from "./MatImage.vue?vue&type=script&lang=ts&"
import style0 from "./MatImage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports